import { defineCustomElement } from '@tyler-components-web/core';
import { SliderComponent } from './slider';
export * from './slider-constants';
export * from './slider';
export function defineSliderComponent() {
    defineCustomElement(SliderComponent);
}
